import { Plugin, PluginKey } from 'prosemirror-state';
export const updateImageSizesPluginKey = new PluginKey('updateImageSizesPlugin');
export default class UpdateImageSizesPlugin extends Plugin {
  constructor(composer) {
    super({
      key: updateImageSizesPluginKey,
      appendTransaction(tr, _oldState, newState) {
        let plugin = this;
        let transaction = tr[0];
        let metaData = transaction.getMeta(updateImageSizesPluginKey);
        if (!metaData) {
          return null;
        }
        let {
          updateSizes
        } = metaData;
        if (!updateSizes) {
          return null;
        }
        newState.doc.descendants((node, pos, _) => {
          if (node.type === newState.schema.nodes.image) {
            let parentWidth = plugin.getParentWidth(pos, composer);
            let newAttrs;
            if (!node.attrs.displayWidth) {
              let displayWidth = Math.min(node.attrs.width, parentWidth);
              newAttrs = Object.assign({}, node.attrs, {
                displayWidth
              });
            }
            if (node.attrs.displayWidth > parentWidth) {
              newAttrs = Object.assign({}, node.attrs, {
                displayWidth: parentWidth
              });
            }
            if (newAttrs) {
              transaction.setNodeMarkup(pos, undefined, newAttrs);
            }
          }
        });
        return transaction;
      }
    });
  }
  getParentWidth(position, composer) {
    let domAtPosition = composer.nodeDom(position);
    let parentWidthString = getComputedStyle(domAtPosition?.parentElement).width;
    return parseInt(parentWidthString.slice(0, -2), 10);
  }
}